import type { SBotUser } from "./user";

// Port of Models/SBotAppearanceModel.swift.

export const DEFAULT_PRIMARY_HEX = "EF2539";
export const DEFAULT_SECONDARY_HEX = "DA1025";

export type SBotAppearanceSource = "organization" | "league" | "legacyTeam" | "defaults";

export interface SBotAppearance {
  name: string;
  primaryColorHex: string;
  secondaryColorHex: string;
  source: SBotAppearanceSource;
}

export function normalizedHex(value: string | undefined | null): string | undefined {
  if (!value) return undefined;
  const trimmed = value.trim();
  const stripped = trimmed.startsWith("#") ? trimmed.slice(1) : trimmed;
  return /^[0-9A-Fa-f]{6}$/.test(stripped) ? stripped.toUpperCase() : undefined;
}

export const isValidHex = (value: string | undefined | null) => normalizedHex(value) !== undefined;

export function makeAppearance(
  name = "SBot Sports",
  primaryColorHex: string | undefined = DEFAULT_PRIMARY_HEX,
  secondaryColorHex: string | undefined = DEFAULT_SECONDARY_HEX,
  source: SBotAppearanceSource = "defaults",
): SBotAppearance {
  return {
    name: name.trim() || "SBot Sports",
    primaryColorHex: normalizedHex(primaryColorHex) ?? DEFAULT_PRIMARY_HEX,
    secondaryColorHex: normalizedHex(secondaryColorHex) ?? DEFAULT_SECONDARY_HEX,
    source,
  };
}

export function defaultAppearance(name = "SBot Sports"): SBotAppearance {
  return makeAppearance(name);
}

/** Fallback branding for states that are not derived from a league or organization. */
export function legacyFallbackAppearance(user: SBotUser | null): SBotAppearance {
  const name = user?.activeContext?.displayName ?? (user ? `${user.firstName} ${user.lastName}`.trim() || "SBot Sports" : "SBot Sports");
  return defaultAppearance(name);
}
